var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportNews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21.065,
    viewBox: "0 0 22 21.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report-news",
    transform: "translate(-64 -83.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21066",
    "data-name": "Path 21066",
    d: "M67.523,83.072v3.963H64v13.137a3.964,3.964,0,0,0,3.963,3.965h14.07A3.965,3.965,0,0,0,86,100.172v-17.1ZM65.295,94.554V88.3h2.228V98.547c0,2.029-.712,2.755-1.281,3.008a3.73,3.73,0,0,1-.948-2.486Zm19.385,0v4.515a3.748,3.748,0,0,1-3.747,3.748H69.038a3.751,3.751,0,0,1-1.174-.192c1.072-.94.927-3.556.927-3.556V88.3h.083V87.035h-.083V84.392H84.68Z",
    transform: "translate(0 0)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21067",
    "data-name": "Path 21067",
    d: "M331.968,244.48h11.923v1.652H331.968Z",
    transform: "translate(-261.388 -157.445)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21068",
    "data-name": "Path 21068",
    d: "M331.968,391.36h4.421v1.1h-4.421Z",
    transform: "translate(-261.388 -300.718)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21069",
    "data-name": "Path 21069",
    d: "M565.248,391.36h6.2v7.715h-6.2Z",
    transform: "translate(-488.94 -300.718)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21070",
    "data-name": "Path 21070",
    d: "M331.968,481.28h4.421v1.1h-4.421Z",
    transform: "translate(-261.388 -388.43)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21071",
    "data-name": "Path 21071",
    d: "M331.968,569.92h4.421v1.1h-4.421Z",
    transform: "translate(-261.388 -474.893)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21072",
    "data-name": "Path 21072",
    d: "M331.968,660.672h4.421v1.1h-4.421Z",
    transform: "translate(-261.388 -563.417)",
    fill: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportNews);
export default __webpack_public_path__ + "static/media/report-news.9724478ffbedca2a9173c32d8f573bb9.svg";
export { ForwardRef as ReactComponent };